import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { ButtonDirective } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
  ],
})
export class AccessDeniedComponent implements OnInit {
  public auth = inject(AuthService);
  private router = inject(Router);

  async ngOnInit() {
    if (this.router.url != '/access-denied') {
      this.auth.redirectUrl = this.router.url;
    } else {
      this.auth.redirectUrl = '/';
    }
  }

  public login() {
    this.auth.login();
  }
  public logout() {
    this.auth.logout();
  }
  public goHome() {
    this.router.navigate(['/']);
  }
}